<template>
  <div class="mt-5">
    <div class="ml-5 media">
      <figure class="media-left" v-if="business.logoId">
        <p class="image is-64x64">
          <img v-lazy="businessLogo">
        </p>
      </figure>
      <div class="content">
          <div class="is-size-7 has-text-weight-medium has-text-primary">{{ business.brandName }}</div>
          <div class="is-size-7">
            <div class="dropdown is-down" v-if="outlet && !resourceId && otherOutlets && otherOutlets.length > 1" :class="{ 'is-active' : isChangeOutletActive }">
              <div class="dropdown-trigger">
                <button class="button is-small is-link is-outlined" aria-haspopup="true" aria-controls="other_outlet_menu" @click="isChangeOutletActive = !isChangeOutletActive">
                  <span>{{ branchName }}</span>
                </button>
              </div>
              <div class="dropdown-menu" id="other_outlet_menu" role="menu">
                <div class="dropdown-content">
                  <template v-for="branchVO in otherOutlets">
                    <a class="dropdown-item" :key="branchVO.listingId" @click="outletTap(branchVO)" v-if="branchVO.listingId != outlet.mid">{{ branchVO.branchName }}</a>
                  </template>
                </div>
              </div>
            </div>
            <div v-else>{{ branchName }}</div>
            <div v-if="businessContact">
              <span class="icon-text">
                <span class="icon is-small">
                    <font-awesome-icon icon="phone"/>
                </span>
                <span>{{ businessContact }}</span>
              </span>
            </div>
            <div v-html="businessHours"></div>
          </div>
      </div>
    </div>
    <div class="content is-size-7">
      <div class="has-text-primary" v-show="isCatLoaded && isPaymentUnavailable"> Cannot make payment through this device</div>
      <div>
        <span class="mr-5" v-if="outlet && outlet.extras && outlet.extras.priceForTwo">
          <span v-html="formatPrice(outlet.extras.priceForTwo)"></span> <span> for two</span>
        </span>
        <span v-if="outlet && outlet.extras && outlet.extras.minOrderAmount" >
          <span v-html="formatPrice(outlet.extras.minOrderAmount)"></span> <span> minimum order</span>
        </span>
      </div>
    </div>
    <div class="is-size-7 has-text-primary ml-5">
      <div v-if="outlet && outlet.extras && outlet.extras.notes"> {{ outlet.extras.notes }}</div>
      <div v-if="outletInfo && outletInfo.unserviceable">
        <div class="is-marginless">We are not delivering to your address at the moment.</div>
        <div>Please try again by choosing a different address.</div>
      </div>
    </div>
    <UserToolbar hideLogOut=true :hideCustInfo='resourceId'></UserToolbar>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import UserToolbar from './auth/UserToolbar'
import Util from '@/util'

export default {
  name: 'WelcomePage',
  components: {
    UserToolbar
  },
  props: ['outletInfo'],
  data () {
    return {
      imgURL: process.env.VUE_APP_IMG_URL,
      remainingAddress: null,
      isChangeOutletActive: false
    }
  },
  computed: {
    ...mapState({
      business: state => state.business.business,
      outlet: state => state.business.business.onlineListing
    }),
    ...mapState("business", ["resourceId", "otherOutlets"]),
    ...mapGetters({
      isPaymentUnavailable: 'business/isPaymentUnavailable',
      isCatLoaded: 'catalog/isDataLoaded',
      businessContact: 'business/businessContact'
    }),
    businessHours () {
      if (!this.business.onlineListing) {
        return ''
      }
      const RL = window.RL
      let obj = {}
      let string = ''

      if (!RL) {
        return string
      }
      try {
        obj = RL.common.getDisplayBizHours(this.business.onlineListing.businessHours.businessDays)
        obj.forEach(function(timeRange) {
          string += '<span>&nbsp;' + timeRange.days + ': ' + timeRange.hours + '</span>';
        });
      } catch (error) {
        console.log(error)
      }

      return string
    },
    branchName () {
      if (!this.business.branchName) {
        return null
      }
      return this.business.branchName
    },
    address () {
      if (!this.business.address) {
        return null
      }
      const address = this.business.address;

      return `${address.addressLine ? address.addressLine : ''} ${address.city} ${address.state}`;
    },
    shortAddress () {
      if (!this.business.address) {
        return null
      }
      const address = this.business.address;

      const addressLine = `${address.addressLine ? address.addressLine : ''} ${address.city} ${address.state}`;
      if (addressLine.length > 60) {
        return addressLine.substr(0, 60);
      }
      return addressLine;
    },
    businessLogo () {
      if (!this.business) {
        return ''
      }
      return [this.imgURL, 'logo', this.business.logoId, 'large'].join('/')
    }
  },

  methods: {
    toggleMore() {
      this.remainingAddress = this.address.substr(60);
    },
    outletTap(outlet) {
      this.isChangeOutletActive = false
      this.$emit('switchOutlet', {
        outletInfo: outlet
      })
    },
    formatPrice(price) {
      return Util.displayPrice(price)
    }
  }
}
</script>
